import FooterLogo from '@/assets/img/logo/greenLogo.svg';
import Logo from '@/assets/img/logo/logo_black.svg';
import * as S from '@/components/Footer/style';
import useIsMobile from '@/hooks/useIsMobile';
import { breakpoints } from '@/styles/breakpoints';

import LineIcon from '../Icon/lineIcon';

const Footer = () => {
	const isMobile = useIsMobile(breakpoints.layout);
	return (
		<S.FooterContainer>
			<S.FooterWrapper>
				<S.FooterContent>
					<S.ImgBox>
						<img src={FooterLogo} alt="FooterLogo" />
					</S.ImgBox>
					<S.FooterAbout>
						<S.ContentBox>
							<S.FooterContact>
								<S.FooterInfo>단체명: 대한화장품학회</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>사업장 주소: 서울시 송파구 법원로 127,316호(문정동, 대명벨리온)</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>TEL: (02) 6713-1968</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>FAX: (02) 6713-1969</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>대표 이메일: scsk1968@naver.com</S.FooterInfo>
							</S.FooterContact>
						</S.ContentBox>
						<S.CopyRight>COPYRIGHT © 대한화장품학회 ALL RIGHT RESERVED.</S.CopyRight>
					</S.FooterAbout>
				</S.FooterContent>
			</S.FooterWrapper>
		</S.FooterContainer>
	);
};

export default Footer;
